import React, { memo, useCallback, useEffect, useMemo } from 'react';
import { RoomConnectedError, SDK_VERSION } from '@salutejs/jazz-sdk-web';
import bem from 'utils/bem.js';
import { Skeleton } from '@mui/material';
import { RoomContext } from './contexts/RoomContext';
import { Room } from './Room';
import { JazzGlobalContextProvider } from './contexts/JazzGlobalContext';
import { useJazzSDK } from './utils/hooks/useJazzSDK';
import { useConferenceRoom } from './utils/hooks/useConferenceRoom';
import { OrderPlaceholder } from './OrderPlaceholder';
import { ConnectButton } from './components/ConnectButton';
import Text from 'components/Text/index.js';
import { Info } from 'components/Info/index.js';
import ErrorBoundary from './utils/ErrorBoundary';
import { authorize } from './utils/authorize';
import { useRoomConnectionStatus } from './utils/hooks/useRoomConnectionStatus';

const { block, el } = bem('conference')

export const App = ({ orderData }) => {
    const data = orderData.read();
    const [ user, order ] = data;
    useEffect(() => {
        console.log(SDK_VERSION);
    }, []);
    return (
        <ErrorBoundary>
            <JazzGlobalContextProvider>
                <Main user={ user } order={ order } />
            </JazzGlobalContextProvider>
        </ErrorBoundary>
    )
}

export const Main = ({ user, order }) => {
    if (!authorize({ user, order })) {
        throw new RoomConnectedError();
    }
    const event = order?.events?.[0];
    //const accessToken = user.isStaff ? event?.accessToken : event?.accessTokenClient;
    const conference = {
        conferenceId: event?.roomId,
        password: event?.roomPassword
    }
    const { sdk, client } = useJazzSDK({ user, serverUrl: 'https://salutejazz.ru' });
    const { connect, room } = useConferenceRoom({ sdk, client, user });

    const dataLoaded = useMemo(() => {
        return Boolean(user) && Boolean(order) && Boolean(room)
    }, [user, order, room]);

    const handleConnect = useCallback(() => {
        return connect(conference)
    }, [conference, sdk, client]);

    const { statusMessage, errorMessage } = useRoomConnectionStatus({ room });

    return (
        <div className={ block() }>
            { !dataLoaded && <Info>Время начала консультации указано по Московскому времени</Info> }
            <div className={ el('layout', {'error': Boolean(errorMessage)}) }>
                { Boolean(errorMessage) && <div className={el('error-message')}>
                    <Text serif>{errorMessage}</Text>
                </div> }
                { !dataLoaded && !Boolean(errorMessage) && <div className={ el('placeholder') }>
                    <OrderPlaceholder order={ order } />
                    { conference && !statusMessage && <ConnectButton onClick={ handleConnect } /> }
                    { statusMessage && <Text>{statusMessage}</Text> }
                </div> }
                { dataLoaded && !Boolean(errorMessage) &&
                    <AppContent user={ user } order={ order } room={ room } sdk={ sdk } /> }
            </div>
        </div>
    )
}

const AppContent = memo(({ user, order, room, sdk }) => {
    return (
        <RoomContext.Provider value={ { user, order, room, sdk } }>
            <Room />
        </RoomContext.Provider>
    )
})

export const AppSkeleton = () => {
    return (
        <div className={ block() }>
            <Info>Время начала консультации указано по Московскому времени</Info>
            <div className={ el('layout') }>
                <Skeleton width={ '100%' } height={ '100%' } style={ { position: 'absolute', transform: 'none' } } />
            </div>
        </div>
    )
}
